
import Vue from "vue";
import { Prop, Component, Watch, PropSync } from "vue-property-decorator";
import notifications from "../../lib/notifications";
import { getModule } from "vuex-module-decorators";
import OrderModule from "@/store/modules/order";
import { formatDateWithTime } from "../../utils";
import { IOrderResource } from "@/store/types";

const orderModule = getModule(OrderModule);

@Component
export default class OrderBarcodes extends Vue {
  transactionsModalVisible: boolean = false;
  selectedBarcode: any = {};
  modalIsLoading: boolean = false;
  barcodeTransactions: Array<any> = [];

  @Prop({ default: false })
  loading: boolean;

  get currentOrder(): IOrderResource {
    return orderModule.currentOrder;
  }

  get currentOrderBarcodeDetails() {
    const details = orderModule.currentOrderBarcodeDetails;
    return details ? details : { receivedDate: "", loadedDate: "", deliveredDate: "" };
  }

  get receivedDate() {
    return formatDateWithTime(this.currentOrderBarcodeDetails.receivedDate);
  }

  get loadedDate() {
    return formatDateWithTime(this.currentOrderBarcodeDetails.loadedDate);
  }

  get deliveredDate() {
    return formatDateWithTime(this.currentOrderBarcodeDetails.deliveredDate);
  }

  formatStatus(status:string) {
    switch (status) {
      case "C":
        status = "Cancelled";
        break;
      case "PL":
        status = "Partial Loaded";
        break;
      case "NS":
        status = "No Scan";
        break;
      case "ND":
        status = "Not Delivered";
        break;
      case "PO":
        status = "Pending Override";
        break;
      case "NR":
        status = "Not Received";
        break;
      case "R":
        status = "Received";
        break;
      case "RR":
        status = "Re-Received";
        break;
      case "L":
        status = "Loaded";
        break;
      case "D":
        status = "Delivered";
        break;
      case "PD":
        status = "Partial Delivery";
        break;
      case "M":
        status = "Short";
        break;
    }
    return status;
  }

  showTransactionsModal(barcode) {
    this.transactionsModalVisible = true;
    this.selectedBarcode = barcode;
  }

  showBarcodeMap() {
    orderModule.showBarcodeMapModal();
  }

  async loadTransactionsModal() {
    try {
      this.modalIsLoading = true;
      var transactions = await orderModule.getBarcodeTransactions({
        orderNumber: orderModule.currentOrder.headerNumber,
        barcodeId: this.selectedBarcode.id
      });
      this.barcodeTransactions = transactions.filter(
        bt => bt.transactionType != "ITEM ADDED" && bt.transactionType != "ITEM REMOVED"
      );
    } catch (ex) {
      notifications.error("Barcode Transactions", "Failed to load barcode transaction list", ex);
    }
    this.modalIsLoading = false;
  }

  format(date) {
    return formatDateWithTime(date);
  }
}
